type MascotProps = {
  /** Rendered box in px. The SVG keeps its own idle animation. */
  size: number
  alt?: string
  className?: string
  priority?: boolean
}

/**
 * The Atirame character. Kept as a plain <img> so the animation declared inside
 * atirame-logo.svg (blink, saccade, mouth) keeps running.
 */
export function Mascot({ size, alt, className = "", priority = false }: MascotProps) {
  return (
    <img
      src="/atirame-logo.svg"
      alt={alt ?? ""}
      aria-hidden={alt ? undefined : true}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`l2-mascot ${className}`.trim()}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
    />
  )
}
